import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from "@angular/core";
import { CoreModule } from "@modules/core/core.module";

// TODO: perhaps move this and add to CoreModule (make more generic)
@Component({
	selector: "collapsible-container-ui",
	templateUrl: "./collapsible-container.component.html",
	styleUrls: ["./collapsible-container.component.scss"],
	standalone: true,
	changeDetection: ChangeDetectionStrategy.OnPush,
	imports: [CoreModule]
})
export class CollapsibleContainerUIComponent {
	@Input() public isExpanded = false;
	@Input() public showLine = true;
	@Output() public expandHandler = new EventEmitter<void>();

	public toggle(): void {
		if (this.isExpanded) {
			this.expandHandler.emit();
		}
	}
}
